import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
    colors: {
        brand: {
            50: '#ffe5f0',
            100: '#fbb6d1',
            200: '#f687b3',
            300: '#f15a95',
            400: '#ec2d77',
            500: '#d3155e',
            600: '#a50e49',
            700: '#770834',
            800: '#49031f',
            900: '#1e000c',
        },
    },
    styles: {
        global: {
            body: {
                bg: 'white',
                color: 'gray.800',
            },
        },
    },
    components: {
        Button: {
            variants: {
                solid: {
                    bg: '#ec2d77',
                    color: 'white',
                    _hover: {
                        bg: '#d3155e',
                        boxShadow: 'md',
                    },
                },
            },
        },
        Card: {
            baseStyle: {
                container: {
                    boxShadow: 'md',
                    rounded: 'lg',
                    p: 4,
                },
            },
        },
    },
});

export default theme;